import { render, staticRenderFns } from "./LetterObservation.vue?vue&type=template&id=9864194a&"
import script from "./LetterObservation.vue?vue&type=script&lang=js&"
export * from "./LetterObservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports